module.exports = __webpack_public_path__ + "static/media/dwayne_J2.jpg_1544912537681.0b2a2596.jpg";